import React, { useEffect, useState } from 'react';
import '../AddType/addType.css';
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from 'firebase/storage';
import { app } from '../../firebase';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';


const Loader = () => (
    <div className="loader">
        <div className="spinner"></div>
    </div>
);

const AddType = () => {
    const [typeName, setTypeName] = useState('');
    const [file, setFile] = useState(null);
    const [imageUrl, setImageUrl] = useState(null);
    const [loading, setLoading] = useState(false); 

    const navigate = useNavigate();
    const location = useLocation();

    
    useEffect(() => {
        if (location.state) {
            setTypeName(location.state.myData.name);
            setImageUrl(location.state.myData.imageUrl);
        }
    }, [location.state]); 

    const fileHandler = (e) => {
        setFile(e.target.files[0]);
        setImageUrl(URL.createObjectURL(e.target.files[0]));
    };

    const submitHandler = async (event) => {
        event.preventDefault();

        let uploadedImageUrl = imageUrl; 

        if (file) {
            const storage = getStorage(app);
            const myRef = storageRef(storage, `type/${Date.now()}`); 

            try {
                setLoading(true); 
                await uploadBytes(myRef, file);
                uploadedImageUrl = await getDownloadURL(myRef);
                console.log("Uploaded Image URL:", uploadedImageUrl);
                alert('Upload successful!');
            } catch (error) {
                console.error("Upload failed:", error);
                alert(`Upload failed: ${error.message}`);
                return; 
            } finally {
                setLoading(false); 
            }
        }

       
        const token = localStorage.getItem('token'); 

        if (location.state) {
            // Update existing type
            axios.put(`https://pkrealestateapi.onrender.com/type/${location.state.myData._id}`, {
                name: typeName,
                imageUrl: uploadedImageUrl 
            }, {
                headers: {
                    'Authorization': `Bearer ${token}` 
                }
            })
            .then(res => {
                console.log(res.data);
                alert('Update successful!'); 
                navigate('/admin/dashboard/type'); 
            })
            .catch(err => {
                console.log(err);
                alert('Update failed. Please try again.'); 
            });
        } else {
            // Create new type
            axios.post('https://pkrealestateapi.onrender.com/type', {
                name: typeName,
                imageUrl: uploadedImageUrl
            }, {
                headers: {
                    'Authorization': `Bearer ${token}` 
                }
            })
            .then(res => {
                console.log(res.data);
                alert('Type added successfully!'); 
                navigate('/admin/dashboard/type'); 
            })
            .catch(err => {
                console.log(err);
                alert('Failed to add type. Please try again.'); 
            });
        }
    };

    return (
        <div className='type-containr'>
            <p>{location.state ? 'Edit Type' : 'Add New Type'}</p>
            <form onSubmit={submitHandler} className='type-form'>
                <input 
                    value={typeName}
                    onChange={(e) => { setTypeName(e.target.value); }} 
                    type='text' 
                    placeholder='Type Name' 
                    required 
                />
                <input 
                    onChange={fileHandler} 
                    type='file' 
                    accept="image/*" 
                />
                {imageUrl && <img style={{ height: '300px' }} src={imageUrl} alt="Preview" />}
                <button className='add-btn' type='submit' disabled={loading}>
                    {loading ? <Loader /> : (location.state ? 'Update' : 'Add')} 
                </button>
            </form>
        </div>
    );
};

export default AddType;